// @flow

import React from "react";

type Props = {
  text?: string,
  step: number,
  totalSteps: number,
  showText: boolean
};

export default ({ text, step, totalSteps, showText = true }: Props) =>
  <div className="progress">
    <div className="bar">
      <div
        className="progressBar"
        style={{ width: `${step / totalSteps * 100}%` }}
      />
    </div>
    {showText && <div className="text">{text} – {step} of {totalSteps}</div>}
    <style jsx>{`
      .progress {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
      }
      .bar {
        height: 8px;
        background: #C9DCDA;
        position: relative;
        width: 100%
      }
      .progressBar {
        background: #3C8287;
        height: 8px;
        position: absolute;
        top: 0;
        left: 0;
      }
      .text {
        color: #646464;
        font-family: FrutigerLTCom;
        font-weight: 300;
        font-size: 14px;
        text-align: center;
        margin: 24px 0;
      }
    `}</style>
  </div>;



// WEBPACK FOOTER //
// ./src/components/Quiz/Progress.js